<template>
  <div class="mc-video-history-new__timeline-search-wrapper" :class="{ disabled: searchDisabled }">
    <date-picker
      ref="pickerTimeNavigation"
      v-model="selectedTime"
      type="time"
      format="HH:mm:ss"
      value-type="HH:mm:ss"
      :show-second="true"
      :clearable="false"
      placeholder="HH:mm:ss"
      :disabled="searchDisabled"
    >
      <template #footer>
        <div class="mc-video-history-new__timeline-search-footer-wrapper">
          <McButton
            size="sm"
            class="mr-2"
            variant="outline-primary"
            :text="$t('global.action.cancel')"
            @click="closePicker"
          />
          <McButton
            size="sm"
            variant="primary"
            :text="$t('global.action.apply')"
            @click="handleClickSearch"
          />
        </div>
      </template>
    </date-picker>
    <McButton variant="icon-only" icon="icon-outline_clock" />
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: {
    McButton,
    DatePicker,
  },
  props: {
    searchDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['goToDatetime'],
  data() {
    return {
      selectedTime: '00:00:00',
    }
  },
  methods: {
    handleClickSearch() {
      this.$emit('goToDatetime', this.selectedTime)
    },
    closePicker() {
      if (this.$refs.pickerTimeNavigation) {
        this.$refs.pickerTimeNavigation.closePopup()
      }
    },
  },
}
</script>
